import {
  Button,
  Text,
  FormControl,
  FormLabel,
  Center,
  Input,
  Box,
  Stack,
  useToast,
  Image,
  Flex,
} from "@chakra-ui/react";
import { useContext, useState } from "react";
import { BsArrowRightShort } from "react-icons/bs";
import { forgotPasswordAPI } from "../Utils/api";
import AuthContext from "../Utils/auth";
import { break_logo_dark, fj_logo } from "../theme";

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const authCtx = useContext(AuthContext);

  const handleChange = (event, setStateFunction) => {
    setStateFunction(event.target.value);
  };

  const handleForgotPassword = async () => {
    setLoading(true);

    try {
      const forgotRes = await forgotPasswordAPI(email);
      if (forgotRes?.status !== "success") {
        const errorMessage =
          forgotRes?.data || "Please check your information and try again.";
        throw new Error(errorMessage);
      }

      toast({
        title: "Request Successful.",
        description: "Please check your email for the New password",
        status: "success",
        position: "top-right",
        duration: 2000,
        isClosable: true,
      });

      authCtx.logout();
      setTimeout(() => {
        window.location = "/login";
      }, 2000);
    } catch (error) {
      console.error("Password reset error:", error);

      const errorMessage =
        error.message || "Please check your information and try again.";

      toast({
        title: "Request Failed",
        description: errorMessage,
        status: "error",
        position: "top-right",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Flex minH="100vh" justify="center" align="center">
      <Box position="relative">
        {/* Forgot Password Card */}
        <Stack
          p={5}
          spacing={4}
          w={"95vw"}
          maxW={"xl"}
          border="1px solid black"
          borderRadius="10px"
        >
          <Center>
            <Image
              src={fj_logo}
              width="auto"
              height="6vh"
              objectFit="contain"
            />
          </Center>
          <Box>
            <Text fontSize="24px" fontWeight={600} letterSpacing="-0.76px">
              Forgot Password
            </Text>
          </Box>
          <Stack spacing={4}>
            <FormControl isRequired id="email">
              <FormLabel fontSize="16px">Email Address</FormLabel>
              <Input
                size="md"
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(event) => handleChange(event, setEmail)}
              />
            </FormControl>
          </Stack>
          <Stack spacing={4}>
            <Button
              size="md"
              isLoading={loading}
              onClick={handleForgotPassword}
              bg="black"
              color="white"
              rightIcon={<BsArrowRightShort />}
              mt="20px"
            >
              Get New Password in your Email
            </Button>
          </Stack>
        </Stack>

        {/* Powered By Section positioned just below the card */}
        <Box
          position="absolute"
          top="100%"
          left="50%"
          transform="translate(-50%, 20px)"
          width="100%"
        >
          <Flex alignItems="center" justify="center" gap="12px">
            <Text
              color="black"
              fontSize={["12px", "12px", "12px", "14px", "14px"]}
              mb="5px"
            >
              POWERED BY
            </Text>
            <Image
              src={break_logo_dark}
              alt="Logo"
              width={["120px", "150px", "200px", "200px", "200px"]}
            />
          </Flex>
        </Box>
      </Box>
    </Flex>
  );
};

export default ResetPassword;
